import React, { useState } from 'react';
import { Pressable, Linking, Text, StyleSheet, View } from 'react-native';
import Toast from 'react-native-toast-message';
import { StatusCodes } from 'http-status-codes';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';

import LoadingButton from './UI/button/LoadingButton';
import Input from './UI/form/input/Input';
import Card, { CARD_TYPES } from './UI/card/Card';
import CardHeader from './UI/card/CardHeader';
import CardBody from './UI/card/CardBody';
import CardFooter from './UI/card/CardFooter';
import Patterns from '../constants/Patterns';
import { ErrorText } from '../constants/Text';

import { COLORS, FONTS, FONT_SIZES } from '@bcm/constants';

import * as contactActions from '../store/actions/contactActions';
import Screens from '../screens/Screens';
import env from '../constants/env';
import { detectUrlParam } from '../src/urlUtils';

const Contact = (props) => {

	const [subject] = useState(detectUrlParam('subject'));
	const [name] = useState(detectUrlParam('name'));
	const [email] = useState(detectUrlParam('email'));

	const dispatch = useDispatch();
	const isLandscape = useSelector( state => state.globals.isLandscape);

	const { handleSubmit, control, formState: { errors } } = useForm({ mode: 'onChange' });
	const onMessage = async (data) => {
		const res = await dispatch(
			contactActions.contact(
				data.email,
				data.name,
				data.subject,
				data.message,
			)
		);
		if (res.status !== StatusCodes.OK) {
			Toast.show({
				type: 'error',
				text1: 'Email couldn\'t send. Please retry later',
			});
		}
		else {
			Toast.show({
				type: 'success',
				text1: 'Thank you for your message!',
			});
			props.navigation.navigate(Screens.home);
		}
		return;
	};

	return (
		<>
			<Card
				cardType={CARD_TYPES.wide}
				isFullscreen={!isLandscape}
			>
				<CardHeader
					isFullscreen={props.isFullscreen}
					title='Connect with BurnCam'
				/>
				<CardBody isFullscreen={props.isFullscreen}>
					<Input
						label={'Email'}
						defaultValue={email ? email : ''}
						control={control}
						autoCorrect={false}
						name={'email'}
						errors={errors['email']}
						rules={{
							required: true,
							pattern: Patterns.email
						}}
						errorTexts={{
							pattern: ErrorText.email,
						}}
					/>
					<Input
						label={'Name'}
						defaultValue={name ? name : ''}
						control={control}
						autoCorrect={false}
						name={'name'}
						rules={{ required: true }}
						errors={errors['name']}
					/>
					<Input
						label={'Subject'}
						defaultValue={subject ? subject : ''}
						control={control}
						autoCorrect={false}
						name={'subject'}
						rules={{ required: true }}
						errors={errors['subject']}
					/>
					<Input
						label={'Message'}
						defaultValue={''}
						control={control}
						autoCorrect={false}
						name="message"
						rules={{ required: true }}
						secureTextEntry
						multiline
						numberOfLines={12}
						errors={errors['message']}
					/>
					<View style={styles.container}>
						<Pressable onPress={async () => await Linking.openURL(env.SUPPORT_URL)}>
							<Text style={styles.text}>Looking for support? Submit a ticket here</Text>
						</Pressable>
					</View>
				</CardBody>
				<CardFooter>
					<LoadingButton
						title="Message"
						name="Message"
						color={COLORS.primary}
						onPress={handleSubmit(onMessage)}
						isLoadingWheel
					/>
					<LoadingButton
						title="Close"
						name="Close"
						color={COLORS.medium}
						onPress={() => props.navigation.navigate(Screens.home)}
						isLoadingWheel
					/>

				</CardFooter>
			</Card>
		</>
	);
};

const styles = StyleSheet.create({
	container: {
		width: '100%',
		height: 40,
		justifyContent: 'center',
		alignItems: 'center',
	},
	text: {
		fontFamily: FONTS.default,
		fontSize: FONT_SIZES.lg,
		color: COLORS.dark,
	},
});

export default Contact;